import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges
} from "@angular/core";
import { SubGridItem } from "@hub/models/common/ui/SubGridItem";
import { eColumnType, eActionState } from "@hub/generated/enums";
import { Constants } from "@hub/common/Constants";
import { ConfirmationService } from "primeng/api";
import { UserController } from "@hub/generated/services";
import { Functions } from "@hub/common/Functions";
import { SearchParameters } from "@hub/generated/models";
import { Note } from "@hub/models/note.model";
import { PageLoaderService } from "@hub/services/PageLoader";
import { NotificationService } from "@hub/services/NotificationService";
import { CurrentUserService } from "@hub/services/CurrentUserService";

@Component({
  selector: "hub-note",
  templateUrl: "./note.component.html"
})
export class NoteComponent implements OnInit, OnChanges {
  constructor(
    protected pageLoaderService: PageLoaderService,
    protected confirmationService: ConfirmationService,
    protected notificationService: NotificationService,
    protected currentUser: CurrentUserService,
    protected userController: UserController
  ) { }

  display: boolean = false;
  isNew: boolean = true;
  selection: Note[] = [];
  columnDetails: SubGridItem[] = [];
  @Input()
  data: Note[] = [];
  @Input()
  contactId;
  @Input()
  noteEnumType: any;
  @Input()
  deleteMessage: string = "";
  @Output()
  getNotesEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  removeNoteEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  updateNoteEmitter: EventEmitter<Note> = new EventEmitter();

  ngOnInit() {
    this.columnDetails = [
      {
        Field: "User",
        Header: "User",
        ColumnType: eColumnType.PlainText
      },
      {
        Field: "Date",
        Header: "Date",
        ColumnType: eColumnType.Date
      },
      {
        Field: "Note",
        Header: "Note",
        ColumnType: eColumnType.PlainText
      }
    ];

    if (this.noteEnumType) {
      this.columnDetails.splice(1, 0, {
        Field: "Type",
        Header: "Type",
        ColumnType: eColumnType.PlainText
      });
    }

    this.getData();
  }

  ngOnChanges() {
  }

  updateNoteHandler(event) {
    this.updateNoteEmitter.emit(event);
  }

  edit() {
    this.display = true;
    this.isNew = false;
  }

  onSave(event) {
    this.selection = [];
    this.getData();
  }

  create() {
    const newNote: any = {
      Id: Constants.GUID_EMPTY,
      ContactId: this.contactId,
      Type: 1,
      Note: "",
      ActionState: eActionState.Inserted,
      Date: new Date()
    };

    this.selection.push(newNote);

    this.display = true;
    this.isNew = true;
  }

  delete() {
    this.confirmationService.confirm({
      key: "common",
      message: Functions.getDeleteMessageWithNumber(
        this.selection.length,
        this.deleteMessage
      ),
      accept: data => {
        this.deleteSelectedItem();
      }
    });
  }

  onSelect(event: any) {
    this.selection = event;
  }

  displayChangeHandler(event) {
    if (!!!event) {
      this.selection = [];
      this.display = event;
    }
  }

  protected deleteSelectedItem() {
    for (const note of this.selection) {
      this.removeNoteEmitter.emit(note.Id);
      this.pageLoaderService.addPageLoader();
    }
    this.selection = [];
  }

  protected getData() {
    this.getNotesEmitter.emit(this.contactId);
    this.selection = [];
  }
}
